import { ActionStatus } from '../../../common/constants/action-status';
import { CustomISBNSearchState } from '../interfaces/custom-isbn.interface';
import { createSlice } from '@reduxjs/toolkit';
import { defaultApiState } from '../../../common/constants/api-constants';
import { getCustomISBNSearch } from '../thunks/custom-isbn.thunk';

export const customISBNSearchInitialState: CustomISBNSearchState = defaultApiState;

/*----- CREATE STORE ------*/
export const customISBNSearchSlice = createSlice({
  name: "customISBN",
  initialState: customISBNSearchInitialState,
  reducers:{},
  extraReducers(builder) {
    builder
      .addCase(getCustomISBNSearch.pending, (state) => {
        state.status = ActionStatus.loading;
      })
      .addCase(getCustomISBNSearch.fulfilled, (state, action) => {
        state.status = ActionStatus.succeeded;
        state.data = action.payload;
      })
      .addCase(getCustomISBNSearch.rejected, (state, action) => {
        state.status = ActionStatus.failed;
        state.error = action.error.message || '';
      })
  }
});


// CREATE REDUCER
export const customISBNSearchReducer = customISBNSearchSlice.reducer;
